import { render, staticRenderFns } from "./TaskRewardsFloatDialog.vue?vue&type=template&id=594467c9&scoped=true"
import script from "./TaskRewardsFloatDialog.vue?vue&type=script&lang=js"
export * from "./TaskRewardsFloatDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskRewardsFloatDialog.vue?vue&type=style&index=0&id=594467c9&lang=less&scoped=true"
import style1 from "./TaskRewardsFloatDialog.vue?vue&type=style&index=1&id=594467c9&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594467c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594467c9')) {
      api.createRecord('594467c9', component.options)
    } else {
      api.reload('594467c9', component.options)
    }
    module.hot.accept("./TaskRewardsFloatDialog.vue?vue&type=template&id=594467c9&scoped=true", function () {
      api.rerender('594467c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TaskRewardsFloatDialog.vue"
export default component.exports